import React from 'react';
import PropTypes from 'prop-types';

import './LinkIcon.scss';
import { constructCn } from '../../../utilities/helperFunctions';

const LinkIcon = ({ className, isActive }) => {
    const cn = constructCn(
        'component-Icons-LinkIcon',
        className,
        isActive && 'active',
        !isActive && 'inactive'
    );

    return (
        <svg
            className={cn}
            viewBox="0 0 30 30"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g
                id="main-tag"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="group" transform="translate(-671.000000, -317.000000)">
                    <g
                        id="link-group"
                        transform="translate(671.000000, 317.000000)"
                    >
                        <rect
                            id="rectangle"
                            x="0"
                            y="0"
                            width="30"
                            height="30"
                        />
                        <g
                            id="link-group"
                            transform="translate(7.000000, 7.000000)"
                        >
                            <path
                                d="M10.3005238,6.05601586 C10.554624,6.32966216 10.553984,6.77401967 10.3026413,7.04469637 L6.61769425,11.0131009 C6.36476359,11.2854878 5.95550545,11.2863746 5.69963377,11.0108205 C5.44553363,10.7371742 5.44617359,10.2928167 5.69751624,10.02214 L9.38246333,6.05373544 C9.63539399,5.78134858 10.0446521,5.78046174 10.3005238,6.05601586 Z M5.69964309,13.9836933 C4.93813069,14.8037836 3.70012565,14.8032697 2.93909975,13.9837033 C2.17743226,13.163446 2.17781796,11.8306624 2.93910906,11.0108105 L4.77945577,9.02889865 C5.03355591,8.75525235 5.03355591,8.31158403 4.77945577,8.03793772 C4.52535562,7.76429142 4.1133779,7.76429142 3.85927776,8.03793772 L2.01893105,10.0198496 C0.749568017,11.3868559 0.748925537,13.606976 2.01892174,14.9746642 C3.2879892,16.3413523 5.34994955,16.3422082 6.61982109,14.9746542 L8.4601678,12.9927424 C8.71426794,12.7190961 8.71426794,12.2754278 8.4601678,12.0017814 C8.20606766,11.7281351 7.79408993,11.7281351 7.53998979,12.0017814 L5.69964309,13.9836933 Z M13.9812265,7.04698682 C15.2510981,5.67943285 15.2503033,3.45886016 13.9812358,2.09217213 C12.7112396,0.724483912 10.6496995,0.725175813 9.38033649,2.09218216 L7.53998979,4.074094 C7.28588965,4.3477403 7.28588965,4.79140862 7.53998979,5.06505493 C7.79408993,5.33870123 8.20606766,5.33870123 8.4601678,5.06505493 L10.3005145,3.08314309 C11.0618056,2.26329113 12.2993903,2.26287577 13.0610578,3.08313306 C13.8220837,3.90269942 13.8225609,5.23593561 13.0610485,6.05602589 L11.2207018,8.03793772 C10.9666017,8.31158403 10.9666017,8.75525235 11.2207018,9.02889865 C11.474802,9.30254496 11.8867797,9.30254496 12.1408798,9.02889865 L13.9812265,7.04698682 Z"
                                id="Combined-Shape"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

LinkIcon.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
};

LinkIcon.defaultProps = {
    className: '',
    isActive: false,
};

LinkIcon.displayName = 'LinkIcon';

export default React.memo(LinkIcon);
